<template>
    <f7-page name="brochure">
        <bc-navbar></bc-navbar>
        <br/>
        <div class="layout_fullwidth_padding">
            <div v-show="isRequestActive" class="loader">
                <looping-rhombuses-spinner :animation-duration="2500" :rhombus-size="15" color="#f9f300" />
            </div>
            <h3>Download Manufacturer PDF Car Brochures</h3>
            <h5>Vehicle Make</h5>
            <select @change="setMakes()" v-model="brochureModel.make">
                <option v-for="make in makes" :key="make" :value="make">{{make}}</option>
            </select>
            <h5>Vehicle Model</h5>
            <select @change="setModels()" v-model="brochureModel.model" :disabled="models.length==0?true:false">
                <option v-for="curModel in models" :key="curModel" :value="curModel">{{curModel}}</option>
            </select>
            <h5>Vehicle Year</h5>
            <select @change="setYears()" v-model="brochureModel.year" :disabled="years.length==0?true:false">
                <option v-for="year in years" :key="year" :value="year">{{year}}</option>
            </select>
            <a class="button_full btyellow external" @click="openBrochure(brochure)" v-for="brochure in brochures" :key="brochure.id"
                target="_blank" :href="brochure.fileUrl" :style="borderStyle" >
                Download {{brochure.year}} {{brochure.make}} {{brochure.model}} {{brochure.submodel}} Brochure</a>

            <h3  style="padding-top: 40px;">Brochure history</h3>
            <ul class="responsive_table" >
                <li class="table_row" :style="borderStyle">
                    <div class="table_section table_section_brochure"  >Brochure</div>
                    <div class="table_section">Date</div>
                </li>
               
                <li class="table_row" v-for="brochureH in brochureHistory" :key="brochureH.openDate">
                    <div class="table_section table_section_brochure"><a :href="brochureH.url"  @click="openBrochure(brochureH)" target="_blank" class="external">{{brochureH.year}} {{brochureH.make}} {{brochureH.model}} {{brochureH.submodel}}</a></div>
                    <div class="table_section">{{(brochureH.openDate != null? new Date(brochureH.openDate).toLocaleDateString():"New brochure")}}</div>
                </li>
            </ul>
        </div>
    </f7-page>
</template>

<script>
    /* eslint-disable */
    import { mapState, mapGetters, mapActions } from 'vuex'
    import { LoopingRhombusesSpinner } from 'epic-spinners'

    export default {
        //Lifecycle
        components: {
            LoopingRhombusesSpinner
        },
        mounted: function () { 
            this.isRequestActive = true;
            this.$store.dispatch('brochure/loadBrochureHistory').then(
                function () {
                    this.$store.dispatch('brochure/loadBrochureMakes')
                        .then(() => { this.isRequestActive = false; });
                        console.log(this.brochureHistory);
                }.bind(this)).catch(x=> {
      this.$f7.mainView.router.load({url: 'error'});
    });

        },
        computed:{ 
        ...mapState({
            makes: state => state.brochure.makes,
            models: state => state.brochure.models,
            years: state => state.brochure.years,
            brochures: state => state.brochure.brochures,
            brochureHistory: state => state.brochure.brochureHistory,
            customization: state => state.common.customization
        }),
        borderStyle: function(){     
            var borderStyle = this.customization.borderOn ? 'solid 1px ' + this.customization.borderColor :  'none';
            var backgroundStyle = this.customization.mainColor;
            var colorStyle = this.customization.fontColor
            return {
                border: borderStyle, 
                background: backgroundStyle,
                color:colorStyle
            };
     }
        },
        methods: {
            setMakes() {
                this.isRequestActive = true; 
                this.$store.dispatch('brochure/loadBrochureModels', this.brochureModel)
                    .then(() => { this.isRequestActive = false; }).catch(x=> {
      this.$f7.mainView.router.load({url: 'error'});
    });
            },
            setModels() {
                this.isRequestActive = true;
                this.$store.dispatch('brochure/loadBrochureYears', this.brochureModel)
                    .then(() => { this.isRequestActive = false; }).catch(x=> {
      this.$f7.mainView.router.load({url: 'error'});
    });
            },
            setYears() {
                this.isRequestActive = true;
                this.$store.dispatch('brochure/loadBrochures', this.brochureModel)
                    .then(() => { this.isRequestActive = false; }).catch(x=> {
      this.$f7.mainView.router.load({url: 'error'});
    });
            },
            openBrochure(brochure) {
                console.log(brochure);
                console.log(this.brochureModel);
                this.isRequestActive = true;
                this.$store.dispatch('brochure/addBrochure', brochure).then(function () {
                    this.$store.dispatch('brochure/loadBrochureHistory').then(()=>{
                        this.isRequestActive = false; 
                    });
                }.bind(this)).catch(x=> {
      this.$f7.mainView.router.load({url: 'error'});
    });
            },
            
           
            // openBrochure(event){
            //     event.preventDefault();
            //     console.log(event);
            //     var win = window.open(event.srcElement.href, '_blank');
            //     win.focus();
            // }
        },
        data() {
            return {
                brochureModel: {
                    make: "Select company/brand",
                    model: "Select model",
                    year: "Select year"
                },
                isRequestActive: false
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .button_full {
        margin-top: 20px
    }

    select {
        width: 100%;
        height: 35px;
        font-size: 18px;
        padding-left: 5px;
    }

    h5 {
        font-weight: bold;
        padding: 10px 0 10px 0;
    }

    .loader {
        position: absolute;
    }
    .table_section_brochure{
        width:55%
    }
</style>


// WEBPACK FOOTER //
// brochures.vue?076d08ba